import { Controller } from 'react-hook-form';
import { includes, map, pipe, propEq, reject, toPairs } from 'ramda';
import { Button, Icon } from '@fasstech/middle-design-system';
import { GranteeTypeEnum } from '@fasstech/oip-core/entities/Grantee/enums';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import handleValidationIndicator from '@@viewCommonComponents/controlled/helpers/handleValidationIndicator.js';

const ControlledGranteeTypeSelect = ({
  rules = {},
  form,
  name,
  getMiddleText,
  disabledTypes = [],
  containerClassName = '',
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const types = pipe(
    toPairs,
    reject(propEq('1', GranteeTypeEnum.ASCENDANT_OR_DEPENDANT)),
    map(([_, CURRENT_GRANTEE_TYPE]) => ({
      label: getMiddleText(`BENEFICIAIRE_TYPE_${CURRENT_GRANTEE_TYPE}_LABEL`),
      value: CURRENT_GRANTEE_TYPE
    }))
  )(GranteeTypeEnum);

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => (
          <div className={'relative'}>
            <div className="flex gap-x-6 w-full">
              {map(
                ({ label, value }) => (
                  <Button
                    className={'w-full'}
                    variant={props.field.value === value ? 'radio-selected' : 'radio'}
                    size="large"
                    key={`select-pack-button-${value}`}
                    onClick={() => props.field.onChange(value)}
                    disabled={includes(value, disabledTypes)}
                    {...extraProps.ButtonProps}
                    {...extraProps}>
                    {label}
                  </Button>
                ),
                types
              )}
            </div>
            <span className="absolute right-[-30px] bottom-[9px]">
              <Icon
                name={
                  handleValidationIndicator(
                    props.field.value,
                    rules,
                    getErrorMessage(form.formState.errors, name)
                  )
                    ? 'indicator_error'
                    : 'indicator_valid'
                }
              />
            </span>
          </div>
        )}
      />
    </div>
  );
};

export default ControlledGranteeTypeSelect;
